import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { homePageService } from "../../services/homePage";

const initialState = {
  msg: "",
  user: null,
  token: "",
  loading: false, 
  error: "",
};

export const faq = createAsyncThunk("faq", async (playload) => {
  const { data, status } = await homePageService.Faq(playload);
  data.status = status;
  return data;
});

export const testimonials = createAsyncThunk("testimonials", async (playload) => {
  const { data, status } = await homePageService.Testimonials(playload);
  data.status = status;
  return data;
});

export const setting = createAsyncThunk("setting", async (playload) => {
  const { data, status } = await homePageService.Setting(playload);
  data.status = status;
  return data;
});

const HomePageSlice = createSlice({
  name: "authUser",
  initialState,
  reducers: {
    logoutHome: (state) => {
      state.token = null;
      localStorage.clear();
      state.msg = "";
      state.user = null;
      state.loading = false;
      state.error = null;
      state.isLoggedIn = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(faq.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(faq.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload.success) {
          state.user = payload.data;
          state.token = payload.data.token;
          state.isLoggedIn = true;
          localStorage.setItem("userAccess", `Bearer ${payload.data.token}`);
        } else {
          state.error = payload.msg || "Login failed";
        }
      })
      .addCase(faq.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "An error occurred";
      });
  }
});

export const { logoutHome } = HomePageSlice.actions;
export default HomePageSlice.reducer;
